import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        idEstado: 2,
    },
    results: [],
}

export const filialSearchSlice = createSlice({
    name: "filialSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
    },
});

export const { setValue, setResults } = filialSearchSlice.actions;
export default filialSearchSlice.reducer;